import { render } from "./KemaskiniAmpunHasil.vue?vue&type=template&id=940e4e56"
import script from "./KemaskiniAmpunHasil.vue?vue&type=script&lang=js"
export * from "./KemaskiniAmpunHasil.vue?vue&type=script&lang=js"

import "./KemaskiniAmpunHasil.vue?vue&type=style&index=0&id=940e4e56&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__